import styled, { css } from "styled-components";

const ChristmasText = () => css`
  position: absolute;
  font-family: SharpSansBold;
  font-size: 36px;
  font-weight: 700;
  top: 17%;
  color: white;
  text-align: -webkit-center;
  width: 100%;
  left: 50%;
  transform: translate(-50%, 0px);
`;

export default styled.div([ChristmasText]);
